import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { faMessages } from '@fortawesome/pro-solid-svg-icons/faMessages';
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faSignalBars } from '@fortawesome/pro-solid-svg-icons/faSignalBars';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import {
	DropdownMenu,
	DropdownMenuEntry,
	MainMenuEntry,
	ToggleSwitch,
	ToggleType,
	Tooltip,
	ToolTipPlacement,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';
import { useNavigate } from 'react-router';
import { useLayoutStore } from '@ukpostbox/frontend-framework/lib/Providers/Stores/LayoutStore';
import { useSite } from '../Providers/SiteInterfaceProvider';

function UserHelpMenu() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const sidebarOpen = useLayoutStore((state) => state.sidebarOpen);

	const { setOnboarding, onboardingActive, setUpdatesModal, UpdateSiteContact } = useSite();
	const { isUltraWide } = useLayout();

	return (
		<DropdownMenu
			title='User Help'
			trigger={
				<Tooltip
					content={t('help.title')}
					position={ToolTipPlacement.Right}
					disabled={sidebarOpen || isUltraWide}
				>
					<MainMenuEntry title={t('help.title')} customCallBack={() => null} icon={faQuestionCircle} />
				</Tooltip>
			}
		>
			<DropdownMenuEntry
				title={t('help.actions.enableOnboarding')}
				onClick={() => setOnboarding(!onboardingActive)}
				addonContentEnd={
					<ToggleSwitch
						type={ToggleType.Switch}
						hideLabel
						label={t('help.actions.enableOnboarding')}
						name='enableOnboarding'
						defaultChecked={onboardingActive}
					/>
				}
			/>

			<DropdownMenuEntry title={t('labels.divider')} sectionDivider />

			<DropdownMenuEntry
				title={t('help.actions.whatsNew')}
				onClick={() => setUpdatesModal(true)}
				icon={faSparkles}
			/>
			<DropdownMenuEntry
				title={t('help.actions.status')}
				onClick={() => navigate('/status')}
				icon={faSignalBars}
			/>

			<DropdownMenuEntry title={t('labels.divider')} sectionDivider />

			<DropdownMenuEntry
				title={t('help.actions.helpCentre')}
				onClick={() => navigate('/help-centre')}
				icon={faQuestionCircle}
			/>

			<DropdownMenuEntry title={t('labels.divider')} sectionDivider />

			<DropdownMenuEntry
				title={t('getInTouch.actions.message')}
				onClick={() => UpdateSiteContact(true)}
				icon={faMessages}
			/>

			<DropdownMenuEntry
				title={t('getInTouch.actions.call')}
				onClick={() => navigate('https://www.ukpostbox.com/contact/callback-request')}
				icon={faPhone}
			/>
		</DropdownMenu>
	);
}
export { UserHelpMenu };
